import { Helper } from '../utitlity/helper';
import { Product } from './product-selector.model';
import { constants } from '../utitlity/constant';
import { ApplicationModel } from './application.model';
declare var GetEF_IDN_CN;
declare var GetEF_NonModifiableData;
declare var GetEF_ModifiableData;
declare var GetEF_HolderSignatureImage;
declare var GetEF_Photography;
declare var GetEF_RootCertificate;
declare var GetEF_HomeAddressData;
declare var GetEF_WorkAddressData;


export class ApplicationSM3Result {
    private relProucts: RelatedProuct[] = [];
    private card: RelatedProuct;
    private crossSellCard: RelatedProuct;
    private overDraft: RelatedProuct;
    private relatedProductAemResponse;

    set productSell(products: any){
        let card = products.filter((product)=>{
            return product.productType ==  constants.PRODUCT_CARD;
        })[0];
        if(card && card.decision != 'DL' && !card.downsell){
            this.card = new RelatedProuct(card,this.relatedProductAemResponse.productCell);;
        }
    }

    set crossSell(crossSell: any){
        let card = crossSell.filter((product)=>{
            return product.productType ==  constants.PRODUCT_CARD;
        })[0];
        if(card && card.decision != 'DL'){
            this.crossSellCard = new RelatedProuct(card,this.relatedProductAemResponse.crossSell);
        }
    }

    set od(crossSell: any){
        let card = crossSell.filter((product)=>{
            return product.productType ==  constants.OVERDRAFT_PRODUCT;
        })[0];
        if(card && card.decision != 'DL'){
            this.overDraft = new RelatedProuct(card,this.relatedProductAemResponse.overDraft);;
        }
    }

    get productSell(){
        return this.card;
    }
    get crossSell(){
        return this.crossSellCard;
    }
    get od(){
        return this.overDraft;
    }


    
    constructor(sm3Response,aemResponse: ApplicationPage){
        this.relatedProductAemResponse = aemResponse.relatedProducts;
        this.relatedProducts = sm3Response;
    }
    setSmg3Response(response){
        let products = response.products;
        let crossSell = response.crossSell;
        if(products && products.length){
            products.map((product)=>{
                return this.setProductDecision(product);
            })
        }
        if(crossSell && crossSell.length){
            crossSell.map((product)=>{
                return this.setProductDecision(product);
            })
        }
    }

    setProductDecision(product){
        if(this.relatedProducts && this.relatedProducts.length){
            let relProduct = this.relatedProducts.filter(relatedProd=>{
                return relatedProd.productCode === product.productCode;
            })[0];
            if(relProduct){
                product.userdecision = relProduct.userDecision;
                product.userLimit = relProduct.maxLimit;
               // product.smg3Decision = relProduct.decision;
            }
        }
       return product;
    }

    get relatedProducts(){
        return this.relProucts;
    }

     set relatedProducts(response: any){
        if(response.decision == 'ON'){
            this.productSell = response.products;
            this.crossSell = response.crossSell;
            this.od = response.crossSell;
            if(this.productSell){
                this.relProucts.push(this.productSell);
            }
            if(this.crossSell){
                this.relProucts.push(this.crossSell);
            }
            if(this.od){
                this.relProucts.push(this.od);
            }
        }
    }
}

export class RelatedProuct {
    type: string;
    title: string;
    private desc: string;
    productUrl: string;
    rangeSupport: boolean;
    userLimit: number;
    maxLimit: number;
    minLimit: number;
    userDecision: string;
    productCode: string;
    value: any;
    productDescription: string;
    constructor(product,aemResponse){
        this.setData(product,aemResponse);
    }
    set description(desc: any){
        if(desc){
           desc = desc.replace('{maxLimit}',this.maxLimit);
           desc = desc.replace('{description}',this.productDescription) 
        }
        this.desc = desc;
    }
    get description(){
        return this.desc;
    }
    getTitle(title: string,maxLimit){
        if(title){
           return title.replace('{amount}',maxLimit)
        }
    }
    setData(product,aemResponse){
        if(product && aemResponse){
            this.type = product.type || product.productType ;
            this.productUrl = aemResponse.thumbnailUrl;
            this.rangeSupport =  aemResponse.rangeSupport;
            this.userLimit = product.userLimit;
            this.maxLimit = product.maxLimit;
            this.minLimit = product.minLimit;
            this.userDecision = product.userDecision;
            this.productDescription = product.productDescription;
            this.title = this.getTitle(aemResponse.title,product.maxLimit);
            this.description = aemResponse.description;
            this.productCode = product.productCode;

        }
    }

}

export class RequestPayload {
    customerInfo: any;
    productDetails: ProductDetails[] = [];
    productDetailsCommon: ProductDetailsCommon = new ProductDetailsCommon();
    eligibilityDetails: any;
    hiddenField: string[];
    rosInfo: any;
    taxInfo: any[];
    constructor(){

    }

    cddSectionPayload(data,applicationData: ApplicationModel){
        this.eligibilityDetails = applicationData.eligibilityDetails;
        this.taxInfo = applicationData.taxInfo;
        this.setCDDSection(data,this.hiddenField,applicationData.taxInfo);
        this.setProductDetails(applicationData.productList);
        this.setProductDetailsCommon(applicationData.productDetailCommon);
    }
     
    resInProgressHandling(data){
        data['emiratesId'] = "111111111111111"
        data['emiratesExp'] = this.emiratesExpDefault();
        data['visaNo'] = "898989/7878"
        data['visaExp'] = "01-Jan-2099"

    }
    emiratesExpDefault(){
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
				"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
			];

			var d = new Date();
            var date;
			//To check if month is nov or dec set month to jan or feb else as it is
			var currentMonth = d.getMonth() + 1;
			if (currentMonth == 11 || currentMonth == 12) {
				var year = d.getFullYear() + 1;
				if (currentMonth == 11) {
					var month = 0;
				} else if (currentMonth == 12) {
					var month = 1;
				}
			} else {
				d.setMonth(d.getMonth() + 2);
				var month = d.getMonth();
				var year = d.getFullYear();
			}

			//To check if date is 29 or 30 and month is dec set date and month else as it is
			if (d.getDate() == 29 && currentMonth == 12) {
				date = "01";
				var month = 3;
			} else if (d.getDate() == 30 && currentMonth == 12) {
				date = "02";
				var month = 3;
			} else {
				date = d.getDate();
            }
            return date + "-" + monthNames[month] + "-" + year;
    }

    personalInfoSectionPayload(data,applicationData: ApplicationModel){
        this.eligibilityDetails = applicationData.eligibilityDetails;
        if(this.eligibilityDetails.residencyStatus == 'I'){
            this.resInProgressHandling(data);
        }
        this.setCustomerInfo(data,this.hiddenField);
        this.setProductDetails(applicationData.productList);
        this.setProductDetailsCommon(applicationData.productDetailCommon);
    }

    payload(data,applicationData: ApplicationModel,isCdd?){
        this.eligibilityDetails = applicationData.eligibilityDetails;
        this.setCustomerInfo(data,this.hiddenField);
        this.setProductDetails(applicationData.productList);
        this.setProductDetailsCommon(applicationData.productDetailCommon);
    }

    setCDDSection(data,hiddenFields,panel?,taxInfo?){
            let rosData = {};
            
            for (let key in data) {
                if (hiddenFields.indexOf(key) == -1) {
                    if(data[key] instanceof Array){
                        let arrKeys = data[key].map(value=> value.code);
                        rosData[key] = arrKeys.join(',');
                    } else if (data[key] && data[key].code) {
                        rosData[key] = data[key].code;
                    } else if (data[key]) {
                        rosData[key] = data[key]
                    }
                } else {
                    rosData[key] = 'NA'
                }
            }
            if(rosData['birthPlace']){
                this.customerInfo['birthPlace'] = rosData['birthPlace'];
                delete rosData['birthPlace'];
            }
            delete rosData['taxResidencePrimary'];
            delete rosData['taxResidency']
            this.rosInfo = rosData;  
                  
        
    }
    setCustomerInfo(data,hiddenFields,panel?) {
        this.customerInfo = this.customerInfo || {};
       
        for (let key in data) {
            if(hiddenFields.indexOf(key) == -1 && key !== 'company'){  
                if(data[key] instanceof Array){
                    let arrKeys = data[key].map(value=> value.code);
                    data[key] = arrKeys.join(',');
                } 
                else  
                if(data[key] && data[key].code){
                    this.customerInfo[key] = data[key].code;
                } else if(typeof data[key] == 'boolean'){
                    this.customerInfo[key] = data[key] ? 'Y' : 'N';
                } else if(data[key]){
                    this.customerInfo[key] = data[key]
                }
        }
     }
     if(this.customerInfo['employmentType'] != 'E' && this.customerInfo['monthlyIncome']){
        this.customerInfo['salary'] = this.customerInfo['monthlyIncome'];
        delete this.customerInfo['monthlyIncome'];
     }
    }

    setProductDetails(products) {
        if(this.productDetails && this.productDetails.length == 0)
        for (let key in products) {
            if (products[key]) {
                let product: Product = products[key];
                let reqProductObj: ProductDetails = new ProductDetails(product);
                if(Object.keys(reqProductObj).length)
                this.productDetails.push(reqProductObj);
            }
        }
    }
    
    setProductDetailsCommon(data){
        this.productDetailsCommon = data
       // this.productDetailsCommon.statusCode = "ARNGEN";
       // this.productDetailsCommon.arnStageCd = arnStageCd;

    }
}
export class ProductDetails {
    productCd: string;
    productDesc: string;
    productPath: string;
    productPriority: number;
    constructor(product?){
        if(product && Object.keys(product).length != 0){
            this.productCd = product.productCd || product.pCode;
            this.productDesc = product.productDesc || product.title;
            this.productPath = product.productPath || product.productPagePath;
            this.productPriority = product.productPriority;
        }   
    }
}

export class ProductDetailsCommon{
    arnRef: string = "";
    marketSectorCd: string = "";
    maintananceId: string = ""; 
    sourceId: string = "STP";
    //sourceDetail: string = "XYZ";
    uniqueJourneyNumber: string= "";
    segNo: string = "1";
    potentialNo: string = "";
    hubIndicator: string = "Y";
    staffId: string = "";
    //promoCode: string = "";
  //  currency: string = "";
    ipSegment: string = "";
    statusCode: string = "ARNGEN";
    arnStageCd: string = "";
    productFlag: string;

    constructor(product?){
        if(product) {
            this.arnRef = product.arnRef;
            this.marketSectorCd = product.marketSectorCd;
            this.maintananceId = product.maintananceId;
            this.sourceId = product.sourceId;
            this.uniqueJourneyNumber = product.uniqueJourneyNumber;
            this.segNo = product.segNo;
            this.potentialNo = product.potentialNo;
            this.hubIndicator = product.hubIndicator;
            this.staffId = product.staffId;
            this.ipSegment = product.ipSegment;
            this.statusCode = product.statusCode;
            this.arnStageCd = product.arnStageCd;
            this.productFlag = product.productFlag;

        }
    }
   

}



export class ApplicationPage {
    relatedProducts: any;
    applicationForm: any;
    pageLabel: any;

    constructor(aemData: any){
        if(aemData && aemData.productCommonContent){
            let commonConntent = aemData.productCommonContent;
            this.relatedProducts = commonConntent.relatedProducts;
            this.pageLabel = commonConntent.pageLabel;
        }
        if(aemData){
            this.applicationForm = aemData.pageForm;
        }

    }

}

export class FraudRequestModel{
    _decisionInfo: FraudProductDecisionInfo[];
    arnRef: string;
    smg3CalOneDecision: string;
    constructor(response?,arn?){
        if(response){
            this.decisionInfo = response;
            this.arnRef = arn;
            this.smg3CalOneDecision = response.decision;
        }
    }
    getRequestPayload(){
        return {
            decisionInfo: this.decisionInfo,
            arnRef: this.arnRef,
            smg3CalOneDecision: this.smg3CalOneDecision
        }
    }

    set decisionInfo(response: any){
        let productDecisions: FraudProductDecisionInfo[] = response.products.map((product)=>{
            return new FraudProductDecisionInfo(product);
        });
        let crossSellDecisions:  FraudProductDecisionInfo[] = response.crossSell.map((product)=>{
            return new FraudProductDecisionInfo(product);
        });

        this._decisionInfo = [...productDecisions,...crossSellDecisions];

    }

    get decisionInfo(){
        return this._decisionInfo
    }

}

export class FraudProductDecisionInfo {
    productCd: string;
    userdecision: string;
    userLimit: number;
    productDescription: string;
    smg3Decision: string;

    constructor(product?){
        if(product){
            this.productCd = product.productCode;
            this.userdecision = product.userdecision;
            this.userLimit = product.userLimit;
            this.productDescription = product.productDescription;
            this.smg3Decision = product.decision
        }
    }

}

export class EidReaderModel {

    validateDate(eidDate){
        var sortMonth = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        var expDateFlag = 0;
        if(eidDate.split('-')[2] > new Date().getFullYear()){
            expDateFlag = 1;
        }else if(eidDate.split('-')[2] == new Date().getFullYear()){
            if(Number(sortMonth.indexOf(eidDate.split('-')[1])+1) > new Date().getMonth()+1){
                expDateFlag = 1;
            }else if(Number(sortMonth.indexOf(eidDate.split('-')[1])+1) == new Date().getMonth()+1){
                if(Number(eidDate.split('-')[0]) > new Date().getDate()){
                    expDateFlag =  1;
                }else{
                    expDateFlag = 0;
                }
            }else{
                expDateFlag =  0;
            }
        }else{
            expDateFlag = 0;
        }
        return expDateFlag;
    }

    setValue(prefillData,fieldId,value){
        if(prefillData){
            // let control = form.controls.field.controls;
            // let origValue = form.value.field[fieldId];
            // control[fieldId].setValue(origValue || value);
            prefillData[fieldId] = prefillData[fieldId] || value;

        }
    }

    setData(prefillData,eidData){
        if(prefillData){
            //   let customerDetails = customerDetailsForm.value.field;
               this.setValue(prefillData,'firstName',eidData.abtPassFName);
               this.setValue(prefillData,'middleName',eidData.abtPassMName);
               this.setValue(prefillData,'lastName',eidData.abtPassLName);
               this.setValue(prefillData,'passportNo',eidData.perInfoPassNum);
               if(this.validateDate(eidData.perInfoPassExDt)){
                   this.setValue(prefillData,'passportExp',eidData);
               }
               this.setValue(prefillData,'conOfCitizen',eidData.passportCountryDesc);
               this.setValue(prefillData,'visaNo',eidData.addResidencyNumber);
               if(this.validateDate(eidData.addResidencyExpiryDate)){
                   this.setValue(prefillData,'visaExp',eidData.addResidencyExpiryDate);
               }
               
               if(this.validateDate(eidData.perInfoEidExDt)){
                   this.setValue(prefillData,'emiratesExp',eidData.perInfoEidExDt);
               } 
               this.setValue(prefillData,'emiratesId',eidData.perInfoEid);
               this.setValue(prefillData,'gender',eidData.perInfoGender);
   
           }
    }

    requestPayload(arn,staffId){
        let param = {
            ef_idn_cn: GetEF_IDN_CN(),
            ef_non_mod_data: GetEF_NonModifiableData(),
            ef_mod_data: GetEF_ModifiableData(),
            ef_sign_image: GetEF_HolderSignatureImage(),
            ef_photo: GetEF_Photography(),
            ef_root_cert: GetEF_RootCertificate(),
            ef_home_address: GetEF_HomeAddressData(),
            ef_work_address: GetEF_WorkAddressData(),
            arn: arn,
            staffId: staffId || ''
        }
        return param;
    }
    constructor(){
        // let customerDetailsForm = forms[0];
        // let personalInfoForm = forms[1];
        // let eidCustomerDetails = eidData.customerDetails;
        // let eidPersonalDetails = eidData.personalInformation;
      

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/application-form.model.ts